// extracted by mini-css-extract-plugin
export default {"table":"components-settings-recommendations-dynamic-rate-ranges-strategy-table-module__table"};